var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollegeEducation1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4965 12.3781V28.3534C28.3234 28.8092 27.9914 29 27.5039 29C18.8288 28.9965 10.1501 29 1.4749 28.9965C0.814369 28.9965 0.5 28.6784 0.5 28.0247C0.5 22.9293 0.5 17.8304 0.5 12.735C0.5 12.0883 0.810837 11.7739 1.45017 11.7739C3.32932 11.7739 5.20493 11.7739 7.08408 11.7739C7.18298 11.7739 7.27835 11.7739 7.38432 11.7739V8.36042C6.88274 8.50883 6.40589 8.65371 5.92904 8.78799C5.45925 8.91873 5.04598 8.70318 4.90116 8.26502C4.74221 7.77739 5.00713 7.35336 5.57935 7.18375C8.21086 6.39929 10.8424 5.61131 13.4774 4.83392C13.6823 4.77385 13.7423 4.68905 13.7388 4.47703C13.7247 3.68551 13.7317 2.89046 13.7317 2.09894C13.7317 1.42049 13.8377 1.25442 14.4452 1H19.9697C20.231 1.11307 20.4783 1.23322 20.5949 1.52297C20.8245 2.08481 20.4288 2.65018 19.7789 2.65371C18.4225 2.66078 17.0626 2.65371 15.7063 2.65371C15.6003 2.65371 15.4943 2.65371 15.3848 2.65371V4.74912C16.8224 5.17668 18.2495 5.60424 19.6765 6.0318C20.9763 6.4205 22.2727 6.80919 23.5725 7.19435C23.9364 7.30389 24.1907 7.51237 24.2295 7.90813C24.2931 8.52297 23.7774 8.95053 23.1734 8.78445C22.6577 8.64311 22.1455 8.4841 21.6192 8.32862V11.7739H21.9336C23.7668 11.7739 25.5965 11.7845 27.4297 11.7668C27.9313 11.7597 28.2916 11.9117 28.5 12.3781H28.4965ZM19.9591 27.3392V27.0353C19.9591 20.7279 19.9591 14.417 19.9626 8.10954C19.9626 7.90106 19.9061 7.80919 19.7012 7.74912C18.0517 7.26502 16.4056 6.76678 14.7561 6.28269C14.6254 6.24382 14.4664 6.24735 14.3357 6.28622C12.6685 6.77739 11.0049 7.28269 9.33764 7.76679C9.10805 7.83392 9.02327 7.91873 9.02681 8.16608C9.03387 14.4558 9.03387 20.7491 9.03387 27.0389C9.03387 27.1343 9.03387 27.2332 9.03387 27.3392H10.8353C10.8353 27.2155 10.8353 27.1095 10.8353 27.0035C10.8353 25.3357 10.8247 23.6678 10.8388 21.9965C10.86 19.7067 12.9758 18.0071 15.2153 18.4629C16.9249 18.8092 18.1117 20.2862 18.1258 22.1025C18.1364 23.7421 18.1258 25.3852 18.1258 27.0247C18.1258 27.1307 18.1364 27.2332 18.14 27.3392H19.9555H19.9591ZM7.37725 27.3392V13.4311H2.15662V27.3392H7.37725ZM21.6192 13.4205V27.3322H26.8398V13.4205H21.6192ZM12.4955 27.3498C13.7918 27.3498 15.0563 27.3498 16.3209 27.3498C16.5045 27.3498 16.4939 27.2367 16.4939 27.1131C16.4939 26.576 16.4939 26.0389 16.4939 25.5018C16.4939 24.3816 16.4904 23.2615 16.4939 22.1378C16.4939 21.3922 16.2255 20.7809 15.5968 20.3675C14.9433 19.9329 14.2404 19.8975 13.5516 20.2615C12.8487 20.6325 12.4884 21.2473 12.4813 22.0424C12.4707 23.7385 12.4778 25.4311 12.4813 27.1272C12.4813 27.1908 12.4884 27.2509 12.4955 27.3498Z",
    fill: "url(#paint0_linear_290_12581)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8348 13.9769C17.7868 15.5639 16.4878 16.8179 14.9308 16.7759C13.3288 16.7339 12.0988 15.4169 12.1438 13.7939C12.1858 12.2669 13.5358 11.0279 15.1018 11.0789C16.6228 11.1269 17.8798 12.4589 17.8348 13.9769ZM14.9818 12.4709C14.1778 12.4739 13.5298 13.1339 13.5358 13.9469C13.5418 14.7389 14.2048 15.3929 14.9968 15.3869C15.7888 15.3809 16.4428 14.7269 16.4458 13.9319C16.4488 13.1309 15.7858 12.4679 14.9818 12.4739V12.4709Z",
    fill: "url(#paint1_linear_290_12581)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05678 22.0951C6.05678 21.6301 6.05678 21.1651 6.05678 20.7031C6.05678 20.4151 6.12277 20.3521 6.41377 20.3491C6.66277 20.3491 6.90878 20.3491 7.15778 20.3491C7.35578 20.3491 7.46078 20.4361 7.46078 20.6431C7.46078 21.6091 7.46078 22.5781 7.46078 23.5441C7.46078 23.7391 7.35278 23.8291 7.17278 23.8351C6.90278 23.8411 6.62978 23.8411 6.35978 23.8351C6.15278 23.8321 6.05078 23.7271 6.05378 23.5141C6.05978 23.0431 6.05378 22.5691 6.05378 22.0981L6.05678 22.0951Z",
    fill: "url(#paint2_linear_290_12581)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.057 16.971C6.057 16.521 6.057 16.074 6.057 15.624C6.057 15.312 6.12 15.249 6.441 15.249C6.681 15.249 6.921 15.249 7.161 15.249C7.362 15.249 7.461 15.345 7.461 15.546C7.461 16.506 7.461 17.466 7.461 18.426C7.461 18.639 7.356 18.738 7.146 18.735C6.891 18.735 6.636 18.735 6.381 18.735C6.144 18.732 6.06 18.648 6.057 18.414C6.054 17.934 6.057 17.454 6.057 16.974V16.971Z",
    fill: "url(#paint3_linear_290_12581)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9909 22.1071C23.9909 22.5631 23.9909 23.0191 23.9909 23.4781C23.9909 23.7541 23.9099 23.8351 23.6309 23.8381C23.3909 23.8411 23.1509 23.8441 22.9109 23.8381C22.6739 23.8321 22.5869 23.7481 22.5869 23.5141C22.5869 22.5631 22.5869 21.6091 22.5869 20.6581C22.5869 20.4421 22.6889 20.3491 22.9019 20.3521C23.1569 20.3551 23.4119 20.3521 23.6669 20.3521C23.9219 20.3551 23.9909 20.4301 23.9939 20.6911C23.9939 21.1621 23.9939 21.6361 23.9939 22.1071H23.9909Z",
    fill: "url(#paint4_linear_290_12581)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5843 16.9981C22.5843 16.5271 22.5843 16.0531 22.5843 15.5821C22.5843 15.3241 22.6563 15.2551 22.9173 15.2521C23.1663 15.2521 23.4123 15.2491 23.6613 15.2521C23.9043 15.2551 23.9853 15.3331 23.9883 15.5701C23.9883 16.5211 23.9883 17.4751 23.9883 18.4261C23.9883 18.6391 23.8833 18.7381 23.6733 18.7381C23.4183 18.7381 23.1633 18.7381 22.9083 18.7381C22.6683 18.7351 22.5843 18.6541 22.5843 18.4171C22.5813 17.9461 22.5843 17.4721 22.5843 17.0011V16.9981Z",
    fill: "url(#paint5_linear_290_12581)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_290_12581",
    x1: 14.5,
    y1: 1,
    x2: 14.5,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_290_12581",
    x1: 14.9893,
    y1: 11.0774,
    x2: 14.9893,
    y2: 16.7769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_290_12581",
    x1: 6.75724,
    y1: 20.3491,
    x2: 6.75724,
    y2: 23.8396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_290_12581",
    x1: 6.75833,
    y1: 15.249,
    x2: 6.75833,
    y2: 18.7351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_290_12581",
    x1: 23.2904,
    y1: 20.3521,
    x2: 23.2904,
    y2: 23.8416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_290_12581",
    x1: 23.2857,
    y1: 15.2507,
    x2: 23.2857,
    y2: 18.7381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollegeEducation1);
export default __webpack_public_path__ + "static/media/college_education1.7763866d4293757c04632a4a7be72de1.svg";
export { ForwardRef as ReactComponent };